export default __webpack_public_path__ + "static/media/file-regular.1caaa464.svg";